import http from "./HttpService";

const endpoint = process.env.VUE_APP_BASE_URL;

export const banUserAccount = (accountId) => {
  return http.put(`/Accounts/${accountId}/ban/account`, {}, {
    baseURL: endpoint,
  });
};

export const unBanUserAccount = (accountId) => {
  return http.put(`/Accounts/${accountId}/unban/account`, {}, {
    baseURL: endpoint,
  });
};

export const fetchUserBanedSections = (accountId) => {
  return http.get(`/Accounts/${accountId}/ban/section`, {
    baseURL: endpoint,
  });
};

export const banUserSection = (accountId, data) => {
  return http.put(`/Accounts/${accountId}/ban/section`, data, {
    baseURL: endpoint,
  });
};

export const unBanUserSection = (accountId, data) => {
  return http.put(`/Accounts/${accountId}/unban/section`, {
    ...data,
    unbanHours: 0,
  }, {
    baseURL: endpoint,
  });
};
